export default "__VITE_ASSET__5b46727a__"